import { BaseMutations } from '@/store/base-mutations';
import { AlfaApiLoanApplicationStatuses } from '../types';
import AlfaApiLoanApplicationStatusesState from './state';

export default class AlfaApiLoanApplicationStatusesMutations extends BaseMutations<AlfaApiLoanApplicationStatusesState> {
  SET_STATUSES(data: AlfaApiLoanApplicationStatuses.AlfaApiLoanApplicationStatus[]) {
    this.state.statuses = data;
  }

  SET_LOADING(value: boolean) {
    this.state.statuses_loading = value;
  }
}
